/* sollie-v2-value-set.js — quantity upsell wiring (updated 2026-11-01: mixed-size set pricing, unit change repricing, exact set contents, sticky bar set price).
   Cards: Single · Set of 2 (15% off) · Set of 3 (20% off) · Set of 4+ (20% off).
   Each set card lists one variant <select> per unit and an action button (Set of 2 jumps to Set of 3; Set of 3 jumps to Set of 4;
   Set of 4 grows up to 12 units at 20% off). Prices are derived from the rendered single price so they follow the market currency.
   After the theme's own add (cart:update from product-form-component) the remaining units are added via /cart/add.js and cart:update
   is re-dispatched. Discounts themselves are Shopify automatic discounts (min qty 2 = 15% off, min qty 3 = 20% off). */
(function () {
  var root = document.querySelector('[data-sv2-value-set]');
  if (!root) return;
  var variants; try { variants = JSON.parse(root.querySelector('[data-sv2-vs-variants]').textContent); } catch (e) { return; }
  var byId = {}; variants.forEach(function (v) { byId[String(v.id)] = v; });
  /* the real product form is the one holding the add-to-cart button (the price block's installments form also posts to /cart/add) */
  function findForm() { var b = document.querySelector('form[action*="/cart/add"] button[type="submit"]'); return (b && b.closest('form')) || document.querySelector('form[action*="/cart/add"]'); }
  var form = findForm();
  var idInput = form && form.querySelector('input[name="id"]');
  var qtyInput = form && form.querySelector('input[name="quantity"]');
  if (qtyInput) qtyInput.value = '1';
  var btn = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
  var btnLabel = btn && (btn.querySelector('.add-to-cart-text, span') || btn);
  var origLabel = btnLabel ? btnLabel.textContent.trim() : 'Add to cart';
  var TIERS = ['2', '3', '4'];
  var MAX = { '2': 2, '3': 3, '4': 12 };
  var currency = (root.getAttribute('data-currency-code') || root.getAttribute('data-currency') || '').trim();
  var currSuffix = (currency && currency !== 'USD') ? ' ' + currency : '';
  /* --- money: learn the format from the rendered single price ("C$259.90", "A$267.00", "£174.00") --- */
  var rawSample = root.querySelector('[data-sv2-vs-price="1"]').textContent.trim();
  var sample = currency ? rawSample.replace(new RegExp('\\s+' + currency + '$'), '').trim() : rawSample;
  var m = sample.match(/^([^\d]*)([\d.,]+)([^\d]*)$/) || ['', '', '0', ''];
  var pre = m[1], suf = m[3], dec = /[.,]\d{2}$/.test(m[2]) ? m[2].slice(-3, -2) : '.', thou = dec === '.' ? ',' : '.';
  var unitCents = Number(root.getAttribute('data-unit')) || 0;             /* shop-currency cents from Liquid */
  var unitShown = Number(m[2].replace(new RegExp('\\' + thou, 'g'), '').replace(dec, '.')) || 0; /* market price shown */
  var fx = unitCents ? unitShown / (unitCents / 100) : 1;                   /* market multiplier */
  function money(cents) { var n = (cents / 100 * fx); var s = n.toFixed(2); var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return pre + parts.join(dec) + suf; }
  function moneyWithCurr(cents) { return money(cents) + currSuffix; }
  function currentVariant() { var id = idInput ? idInput.value : ''; return byId[id] || variants[0]; }
  function tier() { var t = root.querySelector('input[data-sv2-vs-tier]:checked'); return t ? t.value : '1'; }
  function unitsOf(n) { return root.querySelectorAll('[data-sv2-vs-units="' + n + '"] select'); }
  function pctFor(count) { return count >= 3 ? 0.20 : (count >= 2 ? 0.15 : 0); }
  function addUnit(n, value) {
    var box = root.querySelector('[data-sv2-vs-units="' + n + '"]'); if (!box) return;
    var i = box.children.length + 1;
    var row = document.createElement('div'); row.className = 'sv2-vs__unit' + (i > Number(n) ? ' sv2-vs__unit--rm' : '');
    var lab = document.createElement('span'); lab.textContent = '#' + i;
    var sel = document.createElement('select'); sel.setAttribute('aria-label', 'Unit ' + i + ' option');
    variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.title === 'Default Title' ? 'Standard' : v.title; sel.appendChild(o); });
    if (value) sel.value = String(value);
    row.appendChild(lab); row.appendChild(sel);
    if (i > Number(n)) { var rm = document.createElement('button'); rm.type = 'button'; rm.setAttribute('aria-label', 'Remove unit ' + i); rm.textContent = '×'; rm.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); row.remove(); renumber(n); reprice(); relabel(); }); row.appendChild(rm); }
    box.appendChild(row);
  }
  function renumber(n) { [].forEach.call(root.querySelectorAll('[data-sv2-vs-units="' + n + '"] .sv2-vs__unit'), function (r, i) { r.firstChild.textContent = '#' + (i + 1); }); }
  function buildUnits() {
    TIERS.forEach(function (n) { if (unitsOf(n).length) return; var v = currentVariant(); for (var i = 0; i < Number(n); i++) addUnit(n, v && v.id); });
  }
  function syncUnitsToPicker() { var v = currentVariant(); if (!v) return; root.querySelectorAll('.sv2-vs__unit select').forEach(function (s) { s.value = String(v.id); }); }
  function reprice() {
    var v = currentVariant(); if (!v) return;
    var unit = v.price; unitCents = unit;
    root.querySelector('[data-sv2-vs-price="1"]').textContent = moneyWithCurr(unit);
    TIERS.forEach(function (n) {
      var priceEl = root.querySelector('[data-sv2-vs-price="' + n + '"]');
      if (!priceEl) return;
      /* price the set from the variant chosen for each unit (mixed sizes add up correctly) */
      var sels = unitsOf(n); var count = sels.length || Number(n); var pct = pctFor(count);
      var full = 0;
      if (sels.length) { [].forEach.call(sels, function (s) { var u = byId[String(s.value)]; full += u ? u.price : unit; }); } else { full = unit * count; }
      var disc = Math.round(full * (1 - pct));
      priceEl.textContent = moneyWithCurr(disc);
      var wasEl = root.querySelector('[data-sv2-vs-was="' + n + '"]'); if (wasEl) wasEl.textContent = money(full);
      var saveEl = root.querySelector('[data-sv2-vs-save="' + n + '"]'); if (saveEl) saveEl.textContent = money(full - disc);
      var nEl = root.querySelector('[data-sv2-vs-n="' + n + '"]'); if (nEl) nEl.textContent = count;
      var pEl = root.querySelector('[data-sv2-vs-pct="' + n + '"]'); if (pEl) pEl.textContent = Math.round(pct * 100);
      var add = root.querySelector('[data-sv2-vs-add="' + n + '"]');
      if (add) {
        if (n === '2') {
          add.querySelector('span').textContent = 'Want 3? Pick Set of 3 below · 20% off';
          add.setAttribute('data-sv2-vs-jump', '3');
        } else if (n === '3') {
          add.querySelector('span').textContent = 'Want 4 or more? Pick Set of 4 below · 20% off';
          add.setAttribute('data-sv2-vs-jump', '4');
        } else {
          add.hidden = count >= MAX['4'];
        }
      }
    });
  }
  /* the sticky bar shows the set price while a set is chosen (it is re-rendered on variant change, so this re-runs after) */
  function stickySync(t, text) {
    var bar = document.querySelector('sticky-add-to-cart'); if (!bar) return;
    var orig = bar.querySelector('.sticky-add-to-cart__price:not(.sv2-sticky-set)'); if (!orig) return;
    var set = bar.querySelector('.sv2-sticky-set');
    if (t === '1') { if (set) set.remove(); orig.style.display = ''; return; }
    if (!set) { set = document.createElement('div'); set.className = 'sticky-add-to-cart__price sv2-sticky-set'; orig.parentNode.insertBefore(set, orig.nextSibling); }
    set.textContent = text; orig.style.display = 'none';
  }
  function relabel() {
    var t = tier();
    var count = t === '1' ? 1 : (unitsOf(t).length || Number(t));
    var setPrice = t === '1' ? '' : root.querySelector('[data-sv2-vs-price="' + t + '"]').textContent;
    stickySync(t, 'Set of ' + count + ' · ' + setPrice);
    if (!btnLabel) return;
    if (t === '1') { btnLabel.textContent = origLabel; return; }
    btnLabel.textContent = 'Add set of ' + count + ' · ' + setPrice;
  }
  buildUnits(); reprice(); relabel();
  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-sv2-vs-add]'); if (!add) return;
    e.preventDefault(); e.stopPropagation();
    var n = add.getAttribute('data-sv2-vs-add');
    var jump = add.getAttribute('data-sv2-vs-jump');
    if (jump) {
      var targetRadio = root.querySelector('input[data-sv2-vs-tier][value="' + jump + '"]');
      if (targetRadio) {
        targetRadio.checked = true;
        reprice();
        relabel();
        var targetUnits = root.querySelector('[data-sv2-vs-units="' + jump + '"]');
        if (targetUnits) targetUnits.scrollIntoView({ block: 'nearest' });
      }
      return;
    }
    if (unitsOf(n).length >= MAX[n]) return;
    var last = unitsOf(n)[unitsOf(n).length - 1];
    addUnit(n, last ? last.value : (currentVariant() || {}).id);
    reprice(); relabel();
  });
  root.addEventListener('change', function (e) { if (e.target.matches('input[data-sv2-vs-tier], .sv2-vs__unit select')) { reprice(); relabel(); } });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('variant-picker input, .sv3-variant input')) {
      setTimeout(function () { syncUnitsToPicker(); reprice(); relabel(); }, 350);
    }
  });
  document.addEventListener('variant:update', function () {
    setTimeout(function () {
      form = findForm();
      idInput = form && form.querySelector('input[name="id"]');
      qtyInput = form && form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = '1';
      syncUnitsToPicker(); reprice(); relabel();
    }, 50);
  });
  /* ride along on the theme's add: the form adds unit #1 (the picker's variant); we add the rest */
  var extras = null;
  if (form) form.addEventListener('submit', function () {
    if (qtyInput) qtyInput.value = '1';
    var t = tier(); if (t === '1') { extras = null; return; }
    var sels = [].slice.call(unitsOf(t)); if (!sels.length) { extras = null; return; }
    /* the theme's form adds exactly one unit: make that unit #1 of the set (restored right after the form reads it), then add #2..n */
    var first = String(sels[0].value);
    if (idInput && String(idInput.value) !== first) { var prev = idInput.value; idInput.value = first; setTimeout(function () { idInput.value = prev; }, 0); }
    var counts = {};
    sels.slice(1).forEach(function (s) { var id = String(s.value); counts[id] = (counts[id] || 0) + 1; });
    extras = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
  }, true);
  document.addEventListener('cart:update', function (event) {
    var data = event && event.detail && event.detail.data;
    if (!data || data.source !== 'product-form-component' || data.didError) return;
    if (!extras || !extras.length) return;
    var items = extras; extras = null;
    var sections = [].map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.getAttribute('data-section-id'); }).filter(Boolean).join(',');
    var payload = { items: items }; if (sections) payload.sections = sections;
    var url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) return;
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return undefined; }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'sv2-value-set', data: { source: 'sv2-value-set', itemCount: items.reduce(function (s, i) { return s + i.quantity; }, 0), productId: root.getAttribute('data-product-id'), sections: res && res.sections } } }));
        });
      }).catch(function () {});
  });
})();
